/**
 * High level router.
 *
 * Note: It's recommended to compose related routes in internal router
 * components (e.g: `src/pages/auth/AuthPage`, `src/pages/home/HomePage`).
 */

import React from "react";
import { Route, Switch, withRouter } from "react-router-dom";
import PrivateRoute from "./PrivateRoute";

export const Routes = withRouter(({ history, location }) => {
  return (
    <Switch>
      <Route path="/" component={PrivateRoute} />
    </Switch>
  );
});
